import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { SwiperModule } from 'swiper/angular';
import { CollectionContainerComponent } from './collection-container/collection-container.component';
import { FilterModule } from '../filter/filter.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { TableComponent } from './base-templates/table/table.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GridComponent } from './base-templates/grid/grid.component';
import { MatCardModule } from '@angular/material/card';
import { CarouselComponent } from './base-templates/carousel/carousel.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { getPaginatorIntl } from '../../services/localization.service';
import { ExpandableTable } from "./base-templates/expandable-table/expandable-table.component";
import { ItemReviewStatusComponent } from "../../../shared/components/item-review-status/item-review-status.component";
import { SharedDirectiveModule } from "../../../shared/directives/shared-directive.module";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
	declarations: [
		CollectionContainerComponent,
		TableComponent,
		GridComponent,
		CarouselComponent,
		ExpandableTable
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		SharedModule,
		FilterModule,
		SwiperModule,
		MatTableModule,
		MatPaginatorModule,
		MatSortModule,
		MatTooltipModule,
		MatChipsModule,
		MatCardModule,
		MatButtonModule,
		MatIconModule,
		MatMenuModule,
		MatProgressSpinnerModule,
		ItemReviewStatusComponent,
		SharedDirectiveModule,
		MatSlideToggleModule
	],
	providers: [
		{ provide: MatPaginatorIntl, useFactory: getPaginatorIntl }
	],
	exports: [
		CollectionContainerComponent,
		CarouselComponent
	]
})
export class CollectionModule {}
